import React,{useContext, useEffect} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {UserContext} from '../UserContext'
import { Button } from '@mui/material';
import { validateMobileNumber } from 'shared';

// const theme = createTheme();
const validEmailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

function Contact({handleNext, busy = false, inputsDisabled = false}) {

    const {user, setUser} = useContext(UserContext);
    // useEffect(() => {
    //   // Scroll to top of page on render
    //   window.scrollTo(0, 0);
    // }, []);

    return (
          <Box component="form" noValidate sx={{ mt: 2 }} >
            <fieldset disabled={inputsDisabled} style={{ border: 0, margin: 0, padding: 0 }}>
     
              <Grid item xs={12} sx={{ pt:2 }}>
                <TextField   
                  error={user.firstName.length < 2 && user.firstName.length > 0}
                  autoComplete="given-name"
                  name="firstName"
                  required
                  fullWidth
                  id="firstName"
                  value={user.firstName}
                  onChange={event => setUser({...user, firstName: event.target.value})}
                  label="First Name"
                  // autoFocus
                />
              </Grid>
              <Grid item xs={12} sm={6} sx={{ pt:2 }}>
                <TextField
                  error={user.lastName.length < 2 && user.lastName.length > 0}
                  required
                  fullWidth
                  id="lastName"
                  label="Last Name"
                  value={user.lastName}
                  onChange={event => setUser({...user, lastName: event.target.value})}
                  name="lastName"
                  autoComplete="family-name"
                />
              </Grid>
              <Grid item xs={12} sx={{ pt:2 }} >
                <TextField
                  error={!validateMobileNumber(user.mobile) && user.mobile.length > 0}
                  required
                  fullWidth
                  id="phone"
                  type="tel"
                  label="Mobile phone"
                  value={user.mobile}
                  onChange={event => setUser({...user, mobile: event.target.value})}
                  name="phone"
                  autoComplete="phone"
                />
              </Grid>
              <Grid item sx={{ pt:2,}} xs={12} >
                <TextField
                  error={!user.email.match(validEmailRegex) && user.email.length > 0}
                  required
                  fullWidth
                  id="email"
                  type="email"
                  label="E-mail"
                  value={user.email}
                  onChange={event => setUser({...user, email: event.target.value})}
                  name="email"
                  autoComplete="email"
                />
              </Grid>

              <Grid item sx={{ pt:2}} xs={12} >
                <TextField
                  error={user.postcode.length !== 4 && user.postcode.length > 0}
                  required
                  fullWidth
                  id="postcode"
                  label="Postcode"
                  value={user.postcode}
                  onChange={event => setUser({...user, postcode: event.target.value})}
                  name="postcode"
                />
              </Grid>

            </fieldset>
              <Box sx={{mt:1}}>
                <Button
                  size="large"
                  sx={{ borderRadius: '10px', fontWeight: 'bold' }}
                  variant="contained"
                  fullWidth
                  disabled={
                    busy ||
                    user.firstName.length < 2 || 
                    user.lastName.length < 2 || 
                    !validateMobileNumber(user.mobile) || 
                    !user.email.match(validEmailRegex) || 
                    user.postcode.length !== 4
                  }
                  onClick={handleNext}
                  >
                  {busy ? 'Checking…' : 'Continue'}
                  </Button>
              </Box>
          </Box>
    );
}

export default Contact;